export default "__VITE_ASSET__DVF4aagg__"